export default "__VITE_ASSET__B5I3y$qz__"